module.exports = __webpack_public_path__ + "static/img/about-born.45ccd7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/about-born.png
// module id = 41
// module chunks = 0